import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, QrCode } from "lucide-react";

export default function EmployeeQRCard({ open, member, onClose }) {
  if (!member) return null;

  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(member.employee_id || member.id)}&bgcolor=ffffff&color=1a1a1a&margin=10`;

  const handleDownload = async () => {
    try {
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `QR_Card_${member.full_name || 'Karyawan'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Gagal mendownload QR Code:", error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xs bg-[#FFFDF9] border-[#E6D5B8]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#302621]">
            <QrCode className="w-4 h-4 text-[#8C6208]" />
            QR Card Karyawan
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-2">
          {/* Card Visual */}
          <div className="w-full bg-gradient-to-br from-[#302621] to-[#1A1411] rounded-2xl p-5 text-[#FFFDF9] text-center shadow-lg border border-[#E6D5B8]/20">
            <p className="text-xs text-[#D4AF37] mb-1 font-bold uppercase tracking-widest">{member.role === 'developer' ? 'Sistem' : 'Pabrik'}</p>
            <div className="bg-white rounded-xl p-2 mx-auto w-fit mb-3">
              <img src={qrUrl} alt="QR Code" className="w-44 h-44 block rounded-lg" crossOrigin="anonymous" />
            </div>
            {member.photo_url ? (
              <img src={member.photo_url} alt="" className="w-12 h-12 rounded-full object-cover border-2 border-[#D4AF37] mx-auto mb-2" />
            ) : (
              <div className="w-12 h-12 rounded-full bg-white/10 border border-white/20 flex items-center justify-center mx-auto mb-2 text-[#D4AF37]">
                <span className="text-xl font-bold">{member.full_name?.charAt(0)?.toUpperCase()}</span>
              </div>
            )}
            <p className="font-black text-lg leading-tight tracking-tight text-white">{member.full_name}</p>
            <p className="text-[11px] font-medium text-slate-300 uppercase tracking-widest mt-1">{member.position || member.role}</p>
            <p className="text-[10px] text-white/50 mt-2 font-mono bg-white/5 py-1 px-3 rounded-full inline-block">{member.employee_id || "No ID"}</p>
          </div>

          <p className="text-[10px] text-[#7A695B] text-center">
            Scan QR ini untuk verifikasi tugas operasional
          </p>

          <div className="flex w-full gap-2 mt-2">
            <Button variant="outline" size="sm" className="flex-1 border-[#E6D5B8] text-[#7A695B] hover:bg-[#F9F5EC]" onClick={onClose}>
              Tutup
            </Button>
            <Button size="sm" className="flex-1 bg-[#8C6208] hover:bg-[#724F06] text-white gap-2" onClick={handleDownload}>
              <Download className="w-4 h-4" /> Download
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}